import(/* webpackMode: "eager", webpackExports: ["AddWidgetToPlatform"] */ "/vercel/path0/src/components/addWidgetToPlatform/addWidgetToPlatform.comp.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["HowToInstallHero"] */ "/vercel/path0/src/components/howToInstallHero/howToInstallHero.comp.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["InstallGuide"] */ "/vercel/path0/src/components/installGuide/installGuide.comp.tsx");
